import * as React from 'react';

const Croatia = ({
  props,
  width = 24,
  height = 18,
}: {
  props?: React.SVGProps<SVGSVGElement>;
  width?: string | number;
  height?: string | number;
}) => {
  const uniqueId = React.useId();
  const clipPathId = `clip-${uniqueId}`;
  const maskBId = `mask-b-${uniqueId}`;
  const maskCId = `mask-c-${uniqueId}`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 18" fill="none" {...props}>
      <g clipPath={`url(#${clipPathId})`}>
        <mask
          id={maskBId}
          width={24}
          height={18}
          x={0}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'alpha',
          }}
        >
          <path
            fill="#fff"
            d="M21.714 0H2.286C1.023 0 0 1.075 0 2.4v13.2C0 16.925 1.023 18 2.286 18h19.428C22.977 18 24 16.925 24 15.6V2.4C24 1.075 22.977 0 21.714 0Z"
          />
        </mask>
        <g mask={`url(#${maskBId})`}>
          <path
            fill="#fff"
            d="M21.714 0H2.286C1.023 0 0 1.075 0 2.4v13.2C0 16.925 1.023 18 2.286 18h19.428C22.977 18 24 16.925 24 15.6V2.4C24 1.075 22.977 0 21.714 0Z"
          />
          <path fill="#150A99" fillRule="evenodd" d="M0 12h24v6H0v-6Z" clipRule="evenodd" />
          <path fill="red" fillRule="evenodd" d="M0 0h24v6H0V0Z" clipRule="evenodd" />
          <path
            fill="#0091E0"
            fillRule="evenodd"
            d="M9.145 4.8h1.142V6H9.145V4.8Zm2.285-1.2h1.143V6H11.43V3.6Zm2.286 1.2h1.143V6h-1.143V4.8Z"
            clipRule="evenodd"
          />
          <path
            fill="#150A99"
            fillRule="evenodd"
            d="M12.57 3.6h1.144V6H12.57V3.6Zm-2.285 0h1.143V6h-1.143V3.6Z"
            clipRule="evenodd"
          />
        </g>
        <mask
          id={maskCId}
          width={6}
          height={8}
          x={9}
          y={6}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: 'alpha',
          }}
        >
          <path fill="#fff" d="M14.859 10.2c0 1.656-1.28 3-2.857 3-1.578 0-2.857-1.344-2.857-3V6h5.714v4.2Z" />
        </mask>
        <g mask={`url(#${maskCId})`}>
          <path fill="red" d="M14.859 10.2c0 1.656-1.28 3-2.857 3-1.578 0-2.857-1.344-2.857-3V6h5.714v4.2Z" />
          <path
            fill="#fff"
            fillRule="evenodd"
            d="M10.287 12h1.143v1.2h-1.143V12Zm2.286 0h1.143v1.2h-1.143V12Zm-1.143-1.2h1.143V12H11.43v-1.2Zm-1.143-1.2h1.143v1.2h-1.143V9.6Zm2.286 0h1.143v1.2h-1.143V9.6ZM11.43 8.4h1.143v1.2H11.43V8.4Zm-1.143-1.2h1.143v1.2h-1.143V7.2Zm2.286 0h1.143v1.2h-1.143V7.2ZM11.43 6h1.143v1.2H11.43V6Zm2.286 0h1.143v1.2h-1.143V6Zm0 2.4h1.143v1.2h-1.143V8.4Zm0 2.4h1.143V12h-1.143v-1.2Zm-4.571 0h1.142V12H9.145v-1.2Zm0-2.4h1.142v1.2H9.145V8.4Zm0-2.4h1.142v1.2H9.145V6Z"
            clipRule="evenodd"
          />
          <path
            stroke="#000"
            strokeOpacity={0.1}
            d="M21.713.6H2.285C1.338.6.57 1.406.57 2.4v13.2c0 .994.768 1.8 1.715 1.8h19.428c.947 0 1.714-.806 1.714-1.8V2.4c0-.994-.767-1.8-1.714-1.8Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <path fill="#fff" d="M0 0h24v18H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Croatia;
